import React, {Component} from 'react';

import {
    Image,
    Platform,
    StyleSheet,
    TouchableHighlight, TouchableOpacity, ActivityIndicator, Alert, PermissionsAndroid,
    FlatList,

    KeyboardAvoidingView,
    View,
} from 'react-native';

//if comment error !!!!!
import {Calendar, SelectMonth, SelectTime} from '../customviews/dateModern/datePicker/components/index';

import HMTextView from '../customviews/HMTextView';

import i18n from './../I18n/i18n.js';
import * as Colors from '../tools/Colors';
import {moderateScale} from '../tools/Scaling';

import {connect} from 'react-redux';

import {colorPrimary} from '../tools/Colors';

let content = null;

//let chechVersion = false;
//let DataSplashScreen = null;
//let chechVersion_force = null;

let time = 3000;
//import DatePicker from 'react-native-jalaali-date-picker'
// import DatePicker from './PersianDatePicker';
import moment from 'moment-jalaali';
//import fa from "moment/src/locale/fa";
import HMIcon from './HMIcon';

import {DatePicker} from './dateModern/datePicker/DatePicker';
import {typeExport} from '../redux/store/type';
import {getFormatedDate} from './dateModern';

moment.locale('fa');
moment.loadPersian();



class HMDialogSelectDate extends Component {


    constructor(props) {
        super(props);
        content = this;
        this.state = {
            showDialog: true,
            DateTo: '',
            DateFrom: '',
            finalDateTo: props.DateTo,
            selectedDateTo: 0,

            finalDateFrom: props.DateFrom,
            selectedDateFrom: 0,
            indexSelectType: 0,
            dateModal: 0,
        };

        // try {
        //     this.checkSatusWifi()
        //
        // }
        // catch (e) {
        //     alert("kikkkk")
        // }


    }


    render() {
        const {selfStyle, titlee, textt, onPressOk, onPressCancel, onPressOK, numberOfLines, data} = this.props;
        let date = this.state[`finalDate` + this.state.NameDate] ? moment(this.state[`finalDate` + this.state.NameDate], 'jYYYY/jM/jD').format('YYYY-MM-DD') : null;


        return (

            //  this.state.showDialog && !(this.props.wifiIsEnabled && this.props.wifiConnectionStatus) ?
            this.state.showDialog ?
                //  this.state.showDialog && Platform.OS==='android' ?
                <View
                    style={{
                        position: 'absolute', top: 0,
                        bottom: 0,
                        right: 0,
                        left: 0,
                        zIndex: 99999,
                        backgroundColor: 'rgba(0,0,0,0.7)',

                    }}>
                    <TouchableHighlight
                        style={[

                            {
                                position: 'absolute',
                                width: '100%',
                                height: '100%',
                                alignContent: 'center',
                                alignItems: 'center',
                                justifyContent: 'center',

                                // height:"100%",
                                // width:"100%",

                                top: 0,
                                bottom: 0,
                                right: 0,
                                left: 0,
                                //     backgroundColor: 'rgba(0,0,0,0.7)',
                                //  zIndex: 9999
                            },

                        ]}
                        // onPress={onPressCancel}
                        //     onPress={() => {
                        //
                        //     this.setState({
                        //         showDialog: false
                        //     })
                        // }}

                    >
                        <View/>

                    </TouchableHighlight>

                    <TouchableHighlight
                        onPress={onPressCancel}
                        style={{
                            flex: 1,
//backgroundColor:Colors.white,
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}>
                        {
                            <View
                                style={{
                                    // flex: 1,
                                    // justifyContent: "center",
                                    // alignItems: "center",
                                    backgroundColor: Colors.white,
                                    width: '96%',
                                    padding: moderateScale(8),
                                }}>


                                <TouchableOpacity
                                    style={{
                                        width: '100%',
                                        overflow: 'hidden',
                                        borderRadius: moderateScale(4),
                                        borderWidth: moderateScale(1),
                                        borderColor: Colors.gray,
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        paddingHorizontal: moderateScale(10),
                                        paddingVertical: moderateScale(10),
                                        alignItems: 'center',
                                    }}
                                    onPress={() => {
                                        this.setState({NameDate: 'From', showDialogDate: true});

                                    }}>
                                    <HMTextView
                                        noFont
                                        type={'bold'}
                                        text={(this.state.finalDateFrom ? this.state.finalDateFrom : ' انتخاب نشده ')}
                                        style={{
                                            color: Colors.blackLight,
                                            fontSize: moderateScale(12),

                                            //  marginEnd: moderateScale(10)
                                        }}/>
                                    <View style={{alignItems: 'center'}}>
                                        <HMTextView
                                            noFont
                                            type={'bold'}
                                            text={('از تاریخ')}
                                            style={{
                                                color: Colors.blackLight,
                                                fontSize: moderateScale(12),

                                                //  marginEnd: moderateScale(10)
                                            }}/>
                                        <HMIcon name="ios-calendar" style={{
                                            color: colorPrimary,
                                            fontSize: moderateScale(24),
                                            padding: moderateScale(4),
                                            //    alignSelf: "center",
                                        }}/>
                                    </View>

                                </TouchableOpacity>
                                <View style={{height: moderateScale(8)}}/>

                                <TouchableOpacity
                                    style={{
                                        width: '100%',
                                        overflow: 'hidden',
                                        borderRadius: moderateScale(4),
                                        borderWidth: moderateScale(1),
                                        borderColor: Colors.gray,
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        paddingHorizontal: moderateScale(10),
                                        paddingVertical: moderateScale(10),
                                        alignItems: 'center',
                                    }}
                                    onPress={() => {
                                        this.setState({NameDate: 'To', showDialogDate: true});

                                    }}>
                                    <HMTextView
                                        noFont
                                        type={'bold'}
                                        text={(this.state.finalDateTo ? this.state.finalDateTo : ' انتخاب نشده ')}
                                        style={{
                                            color: Colors.blackLight,
                                            fontSize: moderateScale(12),

                                            //  marginEnd: moderateScale(10)
                                        }}/>

                                    <View style={{alignItems: 'center'}}>
                                        <HMTextView
                                            noFont
                                            type={'bold'}
                                            text={('تا تاریخ')}
                                            style={{
                                                color: Colors.blackLight,
                                                fontSize: moderateScale(12),

                                                //  marginEnd: moderateScale(10)
                                            }}/>
                                        <HMIcon name="ios-calendar" style={{
                                            color: colorPrimary,
                                            fontSize: moderateScale(24),
                                            padding: moderateScale(4),
                                            //    alignSelf: "center",
                                        }}/>
                                    </View>


                                </TouchableOpacity>

                                <View
                                    style={{
                                        width: '100%',
                                        height: moderateScale(42),
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginBottom: moderateScale(3),
                                        marginTop: moderateScale(10),
                                    }}
                                >


                                    <TouchableOpacity

                                        onPress={() => {
                                            var x = new Date(this.state.finalDateFrom);
                                            var y = new Date(this.state.finalDateTo);
                                            if (y >= x) {
                                                onPressOk(this.state.finalDateFrom, this.state.finalDateTo);
                                            } else {
                                                alert('تاریخ انتخابی اشتباه است');
                                            }
                                        }

                                        }
                                        style={{
                                            flex: 1,
                                            height: moderateScale(42),
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: Colors.colorPrimary,
                                            borderRadius: moderateScale(6),
                                        }}>
                                        <HMTextView
                                            //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                            text={i18n.t('constant.ok')} type={'bold'}
                                            style={{
                                                fontSize: moderateScale(13),
                                                marginVertical: moderateScale(6),
                                                marginHorizontal: moderateScale(4),
                                                color: Colors.white,
                                            }}/>
                                    </TouchableOpacity>


                                    <View style={{width: moderateScale(8)}}/>
                                    <TouchableOpacity
                                        onPress={
                                            onPressCancel
                                            // this.refs['viewPager'].setPage(this.state.currentPage - 1);
                                            //this.refs['viewPager'].setPage(this.state.currentPage - 1);

                                            //this.goBack();

                                            //this.setState({showDialog: false})
                                        }
                                        style={{
                                            flex: 1,
                                            height: moderateScale(42),
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: Colors.colorPrimary,
                                            borderRadius: moderateScale(6),

                                        }}>

                                        <HMTextView
                                            //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                            text={i18n.t('constant.Cancel')} type={'bold'}
                                            style={{
                                                fontSize: moderateScale(13),
                                                marginVertical: moderateScale(6),
                                                marginHorizontal: moderateScale(4),
                                                color: Colors.white,
                                            }}/>
                                    </TouchableOpacity>
                                </View>


                            </View>


                        }
                    </TouchableHighlight>

                    {

                        this.state.isLoading ?

                            <View
                                style={

                                    {
                                        position: 'absolute',
                                        width: '100%',
                                        height: '100%',
                                        alignContent: 'center',
                                        alignItems: 'center',
                                        justifyContent: 'center',

                                        // height:"100%",
                                        // width:"100%",

                                        top: 0,
                                        bottom: 0,
                                        right: 0,
                                        left: 0,
                                        backgroundColor: 'rgba(0,0,0,0.7)',
                                        // zIndex: 9900
                                    }
                                }
                            >
                                <ActivityIndicator color={Colors.colorPrimary} size={'large'}/>

                            </View>
                            :
                            null
                    }
                    {
                        // this.state.showDialogDate ?
                        //     <TouchableHighlight
                        //         onPress={() => {
                        //             this.onPressBackDate();
                        //         }}
                        //
                        //         style={{
                        //             top: 0,
                        //             bottom: 0,
                        //             right: 0,
                        //             left: 0,
                        //             zIndex: 9900,
                        //             backgroundColor: 'rgba(0,0,0,0.4)',
                        //             justifyContent: 'flex-end',
                        //             position: 'absolute',
                        //             flex: 1,
                        //         }}>
                        //
                        //
                        //         <View style={{backgroundColor: "#fdfdfd"}}>
                        //
                        //             <DatePicker
                        //                 //   ref={view => this._onRef('ref_DatePicker', view)}
                        //                 //   defDateString={content.state[`finalDate`+content.state.NameDate]?content.state[`finalDate`+content.state.NameDate]:null}
                        //                 defDateString={date}
                        //                 // defDate={null}
                        //                 showTitleDate={true}
                        //                 dateBoxStyle={{height: moderateScale(50)}}
                        //                 onChangeDate={(date) => {
                        //                     content.onDayPress(date)
                        //                 }}
                        //                 // onChangeDate={(date)=>{
                        //                 //
                        //                 // }}
                        //             />
                        //
                        //             <View
                        //                 style={{
                        //                     flexDirection: 'row',
                        //                     marginVertical: moderateScale(10),
                        //                     justifyContent: 'space-between',
                        //                     paddingHorizontal: moderateScale(4)
                        //                 }}>
                        //                 <TouchableOpacity
                        //                     style={{
                        //                         backgroundColor: Colors.green,
                        //                         width: "32%",
                        //                         height: moderateScale(40),
                        //                         alignItems: "center",
                        //                         justifyContent: "center",
                        //                         // borderRadius:moderateScale(2)
                        //                     }}
                        //
                        //                     onPress={() => {
                        //                         this.onPressOkDate()
                        //                     }}
                        //
                        //                 >
                        //                     <View
                        //                         style={{
                        //                             flexDirection: "row",
                        //                             alignItems: "center",
                        //                             justifyContent: "center"
                        //                         }}>
                        //                         <HMTextView type={"bold"} text={"تایید"} style={{
                        //                             color: "white",
                        //                             fontSize: moderateScale(16),
                        //                             // marginEnd: moderateScale(10)
                        //                         }}/>
                        //
                        //                     </View>
                        //                 </TouchableOpacity>
                        //                 <TouchableOpacity style={{
                        //                     backgroundColor: Colors.red,
                        //                     width: "32%",
                        //                     height: moderateScale(40),
                        //                     alignItems: "center",
                        //                     justifyContent: "center",
                        //                     // borderRadius:moderateScale(2)
                        //                 }}
                        //                                   onPress={() => {
                        //                                       this.onPressCancelDate(this.state.NameDate)
                        //                                   }}
                        //
                        //                 >
                        //                     <View
                        //                         style={{
                        //                             flexDirection: "row",
                        //                             alignItems: "center",
                        //                             justifyContent: "center"
                        //                         }}>
                        //                         <HMTextView type={"bold"} text={"لغو"} style={{
                        //                             color: "white",
                        //                             fontSize: moderateScale(16),
                        //                             //marginEnd: moderateScale(10)
                        //                         }}/>
                        //
                        //                     </View>
                        //                 </TouchableOpacity>
                        //
                        //                 <TouchableOpacity style={{
                        //                     backgroundColor: Colors.colorDark,
                        //                     width: "32%",
                        //                     height: moderateScale(40),
                        //                     alignItems: "center",
                        //                     justifyContent: "center",
                        //                     // borderRadius:moderateScale(2)
                        //                 }}
                        //                                   onPress={() => {
                        //                                       this.onPressBackDate()
                        //                                   }}
                        //
                        //                 >
                        //                     <View
                        //                         style={{
                        //                             flexDirection: "row",
                        //                             alignItems: "center",
                        //                             justifyContent: "center"
                        //                         }}>
                        //                         <HMTextView type={"bold"} text={i18n.t('constant.Back')} style={{
                        //                             color: "white",
                        //                             fontSize: moderateScale(16),
                        //                             // marginEnd: moderateScale(10)
                        //                         }}/>
                        //
                        //                     </View>
                        //                 </TouchableOpacity>
                        //             </View>
                        //         </View>
                        //
                        //
                        //     </TouchableHighlight>
                        //     :
                        //     null
                    }
                    {
                        date&& <DatePicker
                            // ref={(ref)=>this.ref_DatePicker=ref}
                            ref={(ref) => {this.ref_DatePicker = ref}}
                            mode={'calendar'}
                            isVisibleDatePicker={this.state.showDialogDate}
                            onBackdropPress={() => {
                                this.setState({
                                    showDialogDate: !this.state.showDialogDate,
                                });
                            }}

                            // mode={"datepicker"}
                            onSelectedChange={(date) => {
                                this.setState({
                                    ['Date' + content.state.NameDate]: date,
                                }, () => {

                                });
                                //this.getDataSit(date)
                                // this.getDataSit(date)
                            }
                            }
                            onSelectedDateFinal={(date) => {
                                // this.setState({
                                //     ['Date' + content.state.NameDate]: date,
                                //     showDialogDate: !this.state.showDialogDate,
                                //
                                // }, () => {
                                // });


                                content.setState({
                                        // NameDate: data,
                                        //  finalDate: moment(content.state.Date, 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD'),
                                        //  selectedDate: 1
                                        showDialogDate: !this.state.showDialogDate,
                                        [`finalDate${content.state.NameDate}`]: content.state['Date' + content.state.NameDate] ? content.state['Date' + content.state.NameDate] : moment().format('jYYYY/jMM/jDD'),
                                        ['selectedDate' + content.state.NameDate]: 1,
                                    },
                                    () => {
                                    });
                                //this.getDataSit(date)
                                // this.getDataSit(date)
                            }
                            }
                            onTimeChange={selectedTime => this.setState({
                                STimeSelect: selectedTime,
                            })}

                            isGregorian={false}
                            options={{
                                defaultFont: typeExport.regularFontName,
                                headerFont: typeExport.regularFontName,
                            }}
                            //  selected={getFormatedDate(new Date(), 'jYYYY/jMM/jDD')}
                            selected={getFormatedDate(date, 'jYYYY/jMM/jDD')}
                            // selected={getFormatedDate(new Date(), 'jYYYY/jMM/jDD')}

                            // selected={getFormatedDate("1399-09-20", 'jYYYY/jMM/jDD')}
                            // current={"1399/05/20"}
                            //  selected={"1399/05/20"}
                            //   minimumDate={beginDate}
                            //   maximumDate={endDate}
                            //   selectorStartingYear={1398}
                            arraySelect={[]}
                            style={{
                                width: '100%',
                                //  position: 'absolute', bottom: moderateScale(10),
                                backgroundColor: Colors.white,
                                borderWidth: moderateScale(1),
                                borderColor: Colors.gray,
                            }}
                            /*   arraySelect={[
                                   {name: "1399/05/18", type: 1},
                                   {name: "1399/05/19", type: 1},
                                   {name: "1399/05/20"},
                                   {name: "1399/05/21"},
                                   {name: "1399/05/22"},
                               ]}*/

                        />
                    }


                </View>
                :
                null


        );
    }
    onDayPress(day) {
        content.setState({
                ['Date' + content.state.NameDate]: day.format('jYYYY/jM/jD'),

            }
            , () => {
                //   alert(day.dateString)
                // alert( moment(day.dateString, 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD'))

            },
        );
    }

    onPressOkDate() {
        // this.props.onPressOk
        // if (content.state["Date" + content.state.NameDate]) {
        content.setState({
                // NameDate: data,
                //  finalDate: moment(content.state.Date, 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD'),
                //  selectedDate: 1
                showDialogDate: null,
                [`finalDate${content.state.NameDate}`]: content.state['Date' + content.state.NameDate] ? content.state['Date' + content.state.NameDate] : moment().format('jYYYY/jMM/jDD'),
                ['selectedDate' + content.state.NameDate]: 1,
            },
            () => {
            });
        // }
        // else {
        //     HMAlert(
        //         i18n.t('constant.message'),
        //         "تاریخی را انتخاب نگرده اید!!!",
        //         [
        //             // {text: 'Ask me later', onPress: () => {}},
        //             // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
        //             {text: 'خب', onPress: () => {}},
        //         ],
        //         {cancelable: true}
        //     )
        // }

    }

    onPressCancelDate(name) {
        if (content.state.showDialogDate === null && content.state[`finalDate` + name]) {
            content.setState({

                    showDialogDate: null,
                    ['selectedDate' + name]: 0,
                    ['Date' + name]: 0,
                    ['finalDate' + name]: 0,

                    NameDate: name,

                },
                () => {
                });
        }
        else if (content.state.showDialogDate === null && !content.state[`finalDate` + name]) {
            content.setState({

                    showDialogDate: true,
                    ['selectedDate' + name]: 0,
                    ['Date' + name]: 0,
                    ['finalDate' + name]: 0,

                    NameDate: name,

                },
                () => {
                });
        }
        else if (content.state.showDialogDate !== null && content.state[`finalDate` + name]) {
            content.setState({

                    showDialogDate: null,
                    ['selectedDate' + name]: 0,
                    ['Date' + name]: 0,
                    ['finalDate' + name]: 0,

                    NameDate: name,

                },
                () => {
                });
        } else {
            content.setState({
                    showDialogDate: true,
                    // selectedDate: 0,
                    // Date: 0,
                    // finalDate: 0
                    NameDate: name,
                    ['selectedDate' + name]: 0,
                    ['Date' + name]: 0,
                    ['finalDate' + name]: 0,
                },
                () => {
                });
        }
    }

    onPressBackDate() {
        content.setState({
            showDialogDate: null,
        });
    }
}


const mapStateToProps = state => {
    return {
        //  DataSplashScreen: state.reducerSplashSatiaScreen,
        //  wifiIsEnabled: state.reducerSplashSatiaScreen.wifiIsEnabled,
        // wifiConnectionStatus: state.reducerSplashSatiaScreen.wifiConnectionStatus,

    };
};
const mapDispatchToProps = dispatch => {
    return {
        // setIsConnected: (data) => dispatch(serviceActionSetIsConnected(data)),
        // callServiceRtl: (data) => dispatch(serviceActionRtl(data)),

    };
};
export default connect(mapStateToProps, mapDispatchToProps)(HMDialogSelectDate);

const styles = StyleSheet.create({
    modalBackDrop: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',

        // height:"100%",
        // width:"100%",

        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        backgroundColor: 'rgba(0,0,0,0.7)',
        zIndex: 99999,
    },
    modalDialog: {
        backgroundColor: 'white',
        width: '85%',

        alignItems: 'center',
        justifyContent: 'center',
        padding: moderateScale(15),
        //    flex:1,

        // height: moderateScale(185),
        borderRadius: moderateScale(1),
        marginHorizontal: moderateScale(10),
    },
    modalLoading: {
        textAlign: 'center',
    },

    modalTextTitle: {
        fontSize: moderateScale(16),
        color: 'black',
        //  fontFamily: "IRANSansMobile",
        justifyContent: 'center',
        textAlign: 'center',
        fontWeight: 'bold',
    },
    modalTextDescription: {
        fontSize: moderateScale(14),
        // fontFamily: "IRANSansMobile",
        color: 'black',
        margin: 10,
    },
    modalVeiwOk: {
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',

    },
    modalTextName: {
        fontSize: moderateScale(16),
        color: 'black',
        // fontFamily: "IRANSansMobile",
        marginTop: moderateScale(6),
        marginBottom: moderateScale(6),
    },
    modalTextDesc: {
        fontSize: moderateScale(14),
        color: 'black',
        //fontFamily: "IRANSansMobile",
    },
    buttonShowStyle: {
        padding: moderateScale(10),
        width: '100%',
        marginLeft: moderateScale(6),
        borderRadius: moderateScale(4),
        marginTop: moderateScale(10),

    }, buttonCancelStyle: {
        padding: moderateScale(10),
        width: '100%',
        marginRight: moderateScale(6),
        borderRadius: moderateScale(4),
    },
});
